'use client'
import cl from 'clsx'
import ResultsLcaTool from './results'
import MethodsLcaTool from './methods'
import DescriptionLcaTool from './description'
import styles from './styles.module.css'
import Button from "@/ui/button";
import {scrollTo} from "@/utils/scrollTo";

export default function LcaTool({select, descriptionNumber, dict}) {
    let description
    switch(descriptionNumber) {
        case 1: 
            description = <DescriptionLcaTool dict={dict} />
            break
        case 2:
            description = <MethodsLcaTool dict={dict} />
            break
        case 3:
            description = <ResultsLcaTool dict={dict} />
            break
        default: 
            description = <DescriptionLcaTool />
            break
    }
    const {description_menu, methods_menu, results_menu, btn_begin} = dict.discover;
    return (
        <div className={styles.discover__text_content}>
            <div>
                <div className={styles.discover__text_content_title_wrapper}>
                    <h2 onClick={() => select(1)}
                        className={cl(
                            styles.discover__text_content_title_item,
                            descriptionNumber === 1 && styles.selected,
                            descriptionNumber !== 1 && styles.discover__text_content_title_inactive
                        )}
                    >
                        {description_menu}
                    </h2>
                    <h2 onClick={() => select(2)}
                        className={cl(
                            styles.discover__text_content_title_item,
                            descriptionNumber === 2 && styles.selected,
                            descriptionNumber !== 2 && styles.discover__text_content_title_inactive
                        )}
                    >
                        {methods_menu}
                    </h2>
                    <h2 onClick={() => select(3)}
                        className={cl(
                            styles.discover__text_content_title_item,
                            descriptionNumber === 3 && styles.selected,
                            descriptionNumber !== 3 && styles.discover__text_content_title_inactive
                        )}
                    >
                        {results_menu}
                    </h2>
                </div>
                <div className={styles.discover__text_conten_description}>
                    {description}
                </div>
            </div>
            <div className={styles.discover__btn_wrapper}>
                <Button onClick={(event) => scrollTo(event, "header", 0)} title={btn_begin} type="discover-login"/>
            </div>
        </div>
    );
}